//#region src/files/file-type-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e;
}({});
//#endregion
export { e as FileTypeEnum };
